import * as $ from "jquery";
import { environment } from "../environments/environment";

export class Utils {

    static getEncKey() {
        return "aGJUXb50FSb+l9Lg7ALGRp10M8mXuBGpkNe3Q2DfvBg=";
    }
    static getNonceKey() {
        return "UrtolilI5dicfrKTXPnWX0Hu+C6rE4mN";
    }

    static log(message?: any, ...optionalParams: any[]) {
        if (environment.production == false) {
            console.log(message, optionalParams);
        }
    }

    static remove(arr, key, value) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][key] == value) {
                arr.splice(i, 1);
            }
        }

        return arr;
    }


    static find(arr, key, value) {
        var ret = null
        $.each(arr, function(k, area) {

            if (area[key] == value) {

                ret = area;
            }

        })

        return ret;

    }

    static clone(c: any, empty: any): any {

        for (let prop in c) {
            empty[prop] = c[prop];
        }
        return empty;
    }


    static assign(orgObj) {
        return Object.assign({}, orgObj);
    }

    static pushIn(index, item) {
        item.splice(index, 0, item);
    };

    static randomNumber(min: number, max: number) {
        return Math.floor(Math.random() * (max - min + 1)) + Number(min);
    }

    static b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    static openDownloadFile(base64, blob, mime, filename, open) {
        if (blob == null)
            blob = Utils.b64toBlob(base64, mime, null);

        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
            return;
        }

        var blobUrl = URL.createObjectURL(blob);
        if ((mime != null && mime != "" && open) && (mime == "application/pdf" || mime.indexOf("audio") != -1 || mime.indexOf("video") != -1)) {

            window.open(blobUrl);
        }
        else {
            let a = document.createElement("a");
            if (base64 == null) {
                a.href = blobUrl;
            } else {
                a.href = "data:" + mime + ";base64," + base64;

            }
            a.download = filename;
            document.body.appendChild(a);
            // a.click();
            // a.remove();
            a.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }))


        }
    }

    static randomString(len: number) {


        var text = "";
        var possible = "$@$?ABCDFGHIJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";

        while (text.length < len) {

            let x = possible.charAt(Math.floor(Math.random() * possible.length));
            if (possible.indexOf(x) > 0) {
                text += x;
            }
        }

        Utils.log("PASSWORD: " + text);
        //console.log("PASSWORD: " + text);

        return text;



    }

    static shuffle(arr) {
        var i,
            j,
            temp;
        for (i = arr.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            temp = arr[i];
            arr[i] = arr[j];
            arr[j] = temp;
        }
        return arr;
    };
}



// WEBPACK FOOTER //
// ./src/app/utils.ts